import { useState } from "react";
import PatientProfileComponent from "../../../Patients/profile";
import cogoToast from "cogo-toast";

const ClarificationItemComponent = ({ clarificationItem, onSubmitClick, isSubmitting }) => {

    const [reason, setReason] = useState("");
    const [checked, setChecked] = useState(false);

    const handleChange = () => {
        setChecked(!checked);
        setReason("");
    };

    const handleOnSubmitClick = () => {
        if (reason.length <= 0 && !checked) {
            const { hide } = cogoToast.error(
                "Please write your Response/Notes",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            return;
        }

        let params = clarificationItem;

        if (checked) {
            params = {
                ...params,
                is_discontinue: true
            }
        } else if (reason.length > 0) {
            params = {
                ...params,
                "reason_id": 0,
                "reason": reason
            }
        }

        onSubmitClick(params);
        setReason("")
        setChecked(false);
    }

    return (

        <div className="w-full h-full pt-4">
            <div className="flex flex-col w-full">
                <div className="flex flex-col gap-5 w-full">
                    <PatientProfileComponent item={clarificationItem} />
                </div>
                <div className="w-full p-4 flex flex-col gap-5">
                    <div className="flex flex-row gap-4">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    Drug Name
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{clarificationItem.drg}</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-4">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    SIG/Directions
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{clarificationItem.sig_direction}</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-4">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    Clarification Needed
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{clarificationItem.clarification}</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-4">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%', paddingRight: 10 }} className="text-right">
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={handleChange}
                                    className="h-5 w-5"
                                />
                            </div>
                            <div style={{ width: '10%' }}>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">Discontinuing order and submitting new corrected order to the pharmacy</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-4">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    <span className="text-hlred">*</span>
                                    Response/Notes
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <textarea
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                className={`border focus:outline-none p-2 h-24  rounded-md  font-normal w-full text-black text-sm ${checked ? 'opacity-50 cursor-not-allowed' : ''}`}
                                placeholder="Enter response/notes here..."
                                disabled={checked}
                            />
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button
                            disabled={(reason.length <= 0 && !checked) || isSubmitting}
                            onClick={handleOnSubmitClick}
                            className={
                                (reason.length <= 0 && !checked) || isSubmitting
                                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                            }
                        >
                            SUBMIT
                        </button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ClarificationItemComponent;